import React from "react";
import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { signUp } from "../../apis/api/AuthApi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { countryCode, CountryList } from "../../apis/api/CountryList";
import { MembershipPlanList } from "../../apis/api/MembershipApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Lodderr from "../../components/Lodder/Lodder";

const SignUp = () => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,

    formState: { errors },
    control,
  } = useForm();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [countryCodes, setCountryCodes] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [serverError, setServerError] = useState("");
  const [emailExists, setEmailExists] = useState(false);
  const [membershipPlans, setmembershipPlans] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState({
    telephone: null,
    mobile: null,
    contact: null,
  });
  const [previewUrl, setPreviewUrl] = useState("");

  const handleCountryChange = (field, selectedOption) => {
    setSelectedCountries((prev) => ({
      ...prev,
      [field]: selectedOption,
    }));
  };

  useEffect(() => {
    const fetchAPI = async () => {
      const countryListTemp = await dispatch(CountryList());
      const country = await dispatch(countryCode());
      const planList = await dispatch(MembershipPlanList());

      if (country?.payload?.data) {
        setCountryCodes(country.payload.data.data);
      }
      if(countryListTemp?.payload?.data){
        console.log(countryListTemp);
        setCountryList(countryListTemp.payload.data);
        console.log(countryList)
      }
    };

    fetchAPI();
  }, [dispatch]);

  const CountryCode = useSelector((state) => state.countrySlice.countryCode);
  const { country } = useSelector((state) => state.countrySlice);
  const { MembershiplanList } = useSelector((state) => state.MembershipSlice);

  const { loading } = useSelector((state) => state.AuthSlice);

  useEffect(() => {
    if (CountryCode?.data) {
      setCountryCodes(CountryCode.data.data);
    }

    if (MembershiplanList?.data) {
      setmembershipPlans(MembershiplanList?.data?.data);
    }
  }, [CountryCode, MembershiplanList]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (file) {
      setValue("companyLogo", file, { shouldValidate: true });
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const onSubmit = async (data) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (
        key !== "member_birthday" &&
        key !== "companyEstablishmentDate" &&
        key !== "membershipPlan"
      ) {
        formData.append(key, value);
      }
    });

    const exclusivePlan = membershipPlans.find(
      (plan) => plan.label === "Exclusive Membership Plan"
    );

    if (exclusivePlan) {
      formData.append("membershipPlan", exclusivePlan.value);
    }

    Object.entries(selectedCountries).forEach(([key, value]) => {
      if (value) formData.append(key, value.value);
    });

    const convertToTimestamp = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? "" : date.getTime();
    };

    const birthday = watch("member_birthday");
    const companyDate = watch("companyEstablishmentDate");

    if (birthday) {
      formData.append("member_birthday", convertToTimestamp(birthday));
    }

    if (companyDate) {
      formData.append(
        "companyEstablishmentDate",
        convertToTimestamp(companyDate)
      );
    }

    try {
      const response = await dispatch(signUp(formData));

      if (signUp.rejected.match(response)) {
        const errorPayload = response.payload;
        const errorMsg = errorPayload?.message || "Something went wrong.";
        toast.error(errorMsg);
        return;
      }

      if (signUp.fulfilled.match(response)) {
        const payload = response.payload;

        if (payload?.status === "success") {
          toast.success(payload.message || "Form submitted successfully...");
          navigate("/thankyou");
        } else if (payload?.status === "email_exists") {
          toast.error(payload.message || "Email already exists.");
        } else if (payload?.status === "invalid_referral") {
          toast.error(payload.message || "Invalid referral code.");
        } else {
          toast.error(payload.message || "Unknown issue occurred.");
        }
      }
    } catch (error) {
      console.error("Signup error:", error);
      toast.error("Unexpected error occurred.");
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <div
        className="wrapper bg-login pace-done "
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/logistic.jpg)`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}
      >
        <div className=" d-flex align-items-center justify-content-center my-5 my-lg-0 ">
          <div className="container-fluid">
            <div className="row row-cols-1 row-cols-md-1 row-cols-xl-2">
              <div className="col mx-auto mb-5 mt-5 ">
                <div
                  className="card rounded-4"
                  style={{
                    backgroundColor: "rgb(255 255 255 / 89%)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(7px)",
                    color: "rgb(0 0 0)",
                  }}
                >
                  <div className="card-body">
                    <div className="border p-2 rounded-4">
                      <div className="text-center">
                        <div
                          style={{
                            width: "200px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            margin: "auto",
                            background: "transparent",
                          }}
                        >
                          <img
                            src="assets/images/5ca.png"
                            alt="Logo"
                            style={{
                              maxWidth: "150%",
                              maxHeight: "150%",
                              objectFit: "contain",
                              background: "transparent",
                            }}
                          />
                        </div>

                        <h5 className="mt-3 mb-0">Member Registration</h5>
                        <p className="mb-4 mt-3">
                          Let’s get started! Register below to become a member.
                        </p>
                      </div>

                      <div className="form-body">
                        <form
                          className="row g-3"
                          onSubmit={handleSubmit(onSubmit)}
                        >
                          <div class="container mt-4">
                            <div class="border border p-4 position-relative">
                              <div class="text-center position-absolute top-0 ms-6   translate-middle p-1 rounded-1 text-white bg-primary">
                                <strong>Member Information</strong>
                              </div>
                              <div className="row">
                                {/* First Name */}
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    First Name *
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control rounded-2"
                                    placeholder="First Name"
                                    {...register("member_firstName", {
                                      required: "First Name is required",
                                      pattern: {
                                        value: /^[A-Za-z]+$/,
                                        message: "Only letters are allowed",
                                      },
                                    })}
                                  />
                                  {errors.member_firstName && (
                                    <small className="text-danger">
                                      {errors.member_firstName.message}
                                    </small>
                                  )}
                                </div>

                                {/* Last Name */}
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Last Name *
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control rounded-2"
                                    placeholder="Last Name"
                                    {...register("member_lastName", {
                                      required: "Last Name is required",
                                      pattern: {
                                        value: /^[A-Za-z]+$/,
                                        message: "Only letters are allowed",
                                      },
                                    })}
                                  />
                                  {errors.member_lastName && (
                                    <small className="text-danger">
                                      {errors.member_lastName.message}
                                    </small>
                                  )}
                                </div>

                                {/* Job Title */}
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Job Title *
                                  </label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter Job Title"
                                    {...register("member_jobTitle", {
                                      required: "Job Title is required",
                                      minLength: {
                                        value: 2,
                                        message:
                                          "Job title must be at least 2 characters",
                                      },
                                    })}
                                  />
                                  {errors.member_jobTitle && (
                                    <p className="text-danger">
                                      {errors.member_jobTitle.message}
                                    </p>
                                  )}
                                </div>

                                {/* Member Country */}
                                {/* <div className="col-md-6 mt-2">
                                  <label className="form-label">Member Country *</label>
                                  <input
                                    type="text"
                                    className="form-control rounded-2"
                                    placeholder="Member Country"
                                    {...register("member_Country", {
                                      required: "Country is required",
                                    })}
                                  />
                                  {errors.member_Country && (
                                    <small className="text-danger">{errors.member_Country.message}</small>
                                  )}
                                </div> */}

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Member Country *
                                  </label>
                                  <Select
                                    options={country}
                                    placeholder="Select Country"
                                    classNamePrefix="react-select"
                                    {...register("Membercountry", {
                                      required: " member Country is required",
                                    })}
                                    onChange={(selectedOption) =>
                                      setValue(
                                        "Membercountry",
                                        selectedOption?.value
                                      )
                                    }
                                  />
                                  {errors.country && (
                                    <p className="text-danger">
                                      {errors?.Membercountry?.message}
                                    </p>
                                  )}
                                </div>

                                {/* Email Address */}
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Email Address *
                                  </label>
                                  <Controller
                                    name="member_email"
                                    control={control}
                                    rules={{
                                      required: "Email is required",
                                      pattern: {
                                        value:
                                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                        message: "Enter a valid email",
                                      },
                                    }}
                                    render={({ field }) => (
                                      <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter your email address"
                                        {...register("member_email", {
                                          required: "Email is required",
                                          pattern: {
                                            value:
                                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: "Enter a valid email",
                                          },
                                          onChange: (e) =>
                                            setEmailExists(false),
                                        })}
                                      />
                                    )}
                                  />
                                  {errors.member_email && (
                                    <p className="text-danger">
                                      {errors.member_email.message}
                                    </p>
                                  )}
                                  {emailExists && (
                                    <small className="text-danger">
                                      {emailExists}
                                    </small>
                                  )}
                                </div>

                                {/* Contact Number */}
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Contact Number *
                                  </label>
                                  <div className="input-group">
                                    <Select
                                      value={selectedCountries.contact}
                                      onChange={(value) =>
                                        handleCountryChange("contact", value)
                                      }
                                      options={countryCodes}
                                      placeholder="Select Country Code"
                                      getOptionLabel={(e) => `${e.value}`}
                                    />
                                    <input
                                      type="tel"
                                      className="form-control rounded-end-5"
                                      placeholder="Contact Number"
                                      {...register("member_contactNumber", {
                                        required: "Contact number is required",
                                        pattern: {
                                          value: /^[0-9]{7,15}$/,
                                          message:
                                            "Enter a valid contact number",
                                        },
                                      })}
                                    />
                                  </div>
                                  {errors.member_contactNumber && (
                                    <small className="text-danger">
                                      {errors.member_contactNumber.message}
                                    </small>
                                  )}
                                </div>

                                {/* Birthday */}
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">Birthday</label>
                                  <DatePicker
                                    className="form-control w-100"
                                    placeholderText="Select birthdate"
                                    selected={watch("member_birthday")}
                                    onChange={(date) =>
                                      setValue("member_birthday", date)
                                    }
                                    dateFormat="MM/dd/yyyy"
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={100}
                                    showMonthDropdown
                                  />
                                  {errors.member_birthday && (
                                    <p className="text-danger">
                                      {errors.member_birthday.message}
                                    </p>
                                  )}
                                </div>

                                {/* referral code */}
                                {/* <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Referral Code
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control rounded-2"
                                    placeholder="Enter Referral Code"
                                    {...register("member_referralCode")}
                                    onChange={(e) => {
                                      setValue(
                                        "member_referralCode",
                                        e.target.value
                                      );
                                      setServerError(""); // clear message on change
                                    }}
                                  />
                                  {serverError && (
                                    <small className="text-danger">
                                      {serverError}
                                    </small>
                                  )}
                                </div> */}
                              </div>
                            </div>
                          </div>

                          <div class="container mt-5">
                            <div class="border  p-4 position-relative">
                              <div class="text-center position-absolute top-0 ms-6 translate-middle p-1 rounded-1 bg-primary text-white">
                                <strong>Company Information</strong>
                              </div>
                              <div className="row">
                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Company Name *
                                  </label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter company Name"
                                    {...register("companyName", {
                                      required: "Company Name is required",
                                    })}
                                  />
                                  {errors.companyName && (
                                    <p className="text-danger">
                                      {errors.companyName.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Company Logo *
                                  </label>
                                  <Controller
                                    name="companyLogo"
                                    control={control}
                                    rules={{
                                      required: "Company Logo is required",
                                    }}
                                    render={({ field }) => (
                                      <>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          className={`form-control ${
                                            errors.companyLogo
                                              ? "is-invalid"
                                              : ""
                                          }`}
                                          onChange={(e) => {
                                            const file = e.target.files[0];
                                            field.onChange(file);
                                            setPreviewUrl(
                                              URL.createObjectURL(file)
                                            );
                                          }}
                                        />
                                        {errors.companyLogo && (
                                          <p className="invalid-feedback d-block">
                                            {errors.companyLogo.message}
                                          </p>
                                        )}
                                        {previewUrl && (
                                          <img
                                            className="w-100 mt-3 mb-3"
                                            src={previewUrl}
                                            alt="Preview"
                                            style={{
                                              maxHeight: "150px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  />
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Contact Number *
                                  </label>
                                  <div className="input-group">
                                    <Select
                                      value={selectedCountries.telephone}
                                      onChange={(value) =>
                                        handleCountryChange("telephone", value)
                                      }
                                      options={countryCodes}
                                      placeholder="Select country code"
                                      getOptionLabel={(e) => `${e.value}`}
                                    />
                                    <input
                                      type="tel"
                                      className="form-control"
                                      placeholder="Contact Number"
                                      {...register("company_telephone", {
                                        required: "Telephone is required",
                                      })}
                                    />
                                  </div>
                                  {errors.company_telephone && (
                                    <p className="text-danger">
                                      {errors.company_telephone.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Number Of Employees *
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter number of employees"
                                    {...register("numEmployees", {
                                      required:
                                        "Number of Employees is required",
                                    })}
                                  />
                                  {errors.numEmployees && (
                                    <p className="text-danger">
                                      {errors.numEmployees.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Country *
                                  </label>
                                  <Select
                                    options={country}
                                    placeholder="Select Country"
                                    classNamePrefix="react-select"
                                    {...register("country", {
                                      required: "Country is required",
                                    })}
                                    onChange={(selectedOption) =>
                                      setValue("country", selectedOption?.value)
                                    }
                                  />
                                  {errors.country && (
                                    <p className="text-danger">
                                      {errors.country.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">City *</label>
                                  <input
                                    type="text"
                                    className="form-control rounded-2"
                                    placeholder="Enter City"
                                    {...register("city", {
                                      required: "City is required",
                                    })}
                                  />
                                  {errors.city && (
                                    <p className="text-danger">
                                      {errors.city.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">Email *</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter email"
                                    {...register("email", {
                                      required: "Email is required",
                                    })}
                                  />
                                  {errors.email && (
                                    <p className="text-danger">
                                      {errors.email.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-6 mt-2">
                                  <label className="form-label">
                                    Company Establishment Date *
                                  </label>

                                  <Controller
                                    name="companyEstablishmentDate"
                                    control={control}
                                    rules={{
                                      required:
                                        "Company Establishment Date is required",
                                    }}
                                    render={({ field }) => (
                                      <DatePicker
                                        className="form-control w-100"
                                        placeholderText="Select Establishment Date"
                                        selected={field.value}
                                        onChange={(date) =>
                                          field.onChange(date)
                                        }
                                        dateFormat="MM/dd/yyyy"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={100}
                                        showMonthDropdown
                                      />
                                    )}
                                  />

                                  {errors.companyEstablishmentDate && (
                                    <p className="text-danger">
                                      {errors.companyEstablishmentDate.message}
                                    </p>
                                  )}
                                </div>

                                {/* <div className="col-md-12 mt-2">
                                  <label className="form-label">
                                    Membership Plan *
                                  </label>

                                  <Controller
                                    name="membershipPlan"
                                    control={control}
                                    rules={{
                                      required: "Membership Plan is required",
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={membershipPlans}
                                        placeholder="Select Membership Plan"
                                        classNamePrefix="react-select"
                                        isClearable
                                      />
                                    )}
                                  />

                                  {errors.membershipPlan && (
                                    <p className="text-danger">
                                      {errors.membershipPlan.message}
                                    </p>
                                  )}
                                </div> */}

                                <div className="col-md-12 mt-2">
                                  <label className="form-label">
                                    Company Address *
                                  </label>
                                  <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter Address your company"
                                    {...register("companyAddress", {
                                      required: "Company Address is required",
                                    })}
                                  ></textarea>
                                  {errors.companyAddress && (
                                    <p className="text-danger">
                                      {errors.companyAddress.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-md-12 mt-2">
                                  <label className="form-label">
                                    About Your Company *
                                  </label>
                                  <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter about your company"
                                    {...register("aboutCompany", {
                                      required:
                                        "About Your Company is required",
                                    })}
                                  ></textarea>
                                  {errors.aboutCompany && (
                                    <p className="text-danger">
                                      {errors.aboutCompany.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-12">
                                  <div className="d-grid">
                                    <button
                                      type="submit"
                                      className="btn btn-gradient-info rounded-5 mt-4"
                                    >
                                      <i className="bx bxs-lock-open"></i>{" "}
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default SignUp;
